import type {
  IOvieHealthSentimentBuckets,
  IOvieHealthSentimentDailyPoint,
} from './analytics-common';

export interface IOvieHealthSentimentAnalytics
  extends IOvieHealthSentimentBuckets {
  total: number;
  dailyTrend: IOvieHealthSentimentDailyPoint[];
}
